<template>
  <div class="person-detail-view page" :class="pageCollection">
    <div class="page__inner">
      <AppPageLoader :collection="pageCollection" @loaded="onPageLoaded">
        <AppPersonHero
          :title="state.data.title"
          :introduction="state.data.introduction"
          :image="state.data?.image"
          :belongs-to="state.data?.belongs_to as TTag[]"
          class="person-detail-view__person-hero"
        />
        <AppDynamicBlock
          :is="useBlock(block)"
          v-for="block in state.data.content"
          :key="`block_${block.id}`"
          :data="block"
          class="person-detail-view__dynamic-block"
        />
        <ClientOnly>
          <LayoutsShare v-if="state.data?.share" />
        </ClientOnly>
        <AppRelatedPersonsBlock v-if="state.data" :data="state.data" />
        <AppGridBlockStatic v-if="state.data" variant="more" />
        <AppGridBlockStatic v-if="state.data" variant="other" />
      </AppPageLoader>
    </div>
    <AppAnimatedTitle />
    <LayoutsFooter />
  </div>
</template>

<script setup lang="ts">

import { reactive } from 'vue'
import { TPersonPage } from '~/types/page-types'
import { TTag } from '~/types/other-types'

const pageCollection = 'person_page'

type TState = {
  data?: TPersonPage;
};

const state: TState = reactive({
  data: undefined
})

const onPageLoaded = (data) => {
  state.data = data
}

</script>

<style scoped lang="postcss">
.person-detail-view {
  &__person-hero {
    @mixin app-show-hero;
  }

  &__dynamic-block {
    position: relative;
    z-index: 10;
  }
}
</style>
